import React, { useState, useEffect, useLayoutEffect } from 'react'
import { graphql, navigate } from 'gatsby'
import Layout from '../templates/Master'
import PageBuilder from '../views/pageBuilder'
import Loader from '../components/loaders/PageLoader'
import { connect } from 'react-redux'
import {
    onSnapshot,
    query as fsQuery,
    collection,
    doc,
    where,
} from 'firebase/firestore'
import { db } from '../system/firebase/index'
import { dialogState } from '../system/redux/reducers/dialog'
import { previewState } from '../system/redux/reducers/preview'

const Page = ({
    data,
    dispatch,
    location,
    isAuthenticated,
    isVerifying,
    verificationComplete,
    params,
}) => {
    const fallback = <Loader />
    const [pageData, setPageData] = useState(false)
    const queryParams = new URLSearchParams(location.search)
    const id = queryParams.get('id')
    const auxData = {
        collection: data.allCollection.edges,
        post: data.allPost.edges,
        page: data.allPage.edges,
    }

    useEffect(() => {
        if (location.search) {
            if (
                queryParams.get('preview') === 'true' &&
                queryParams.get('id')
            ) {
                dispatch(previewState(queryParams.get('id')))
            }
        }
    }, [location, isVerifying, isAuthenticated, verificationComplete])

    useLayoutEffect(() => {
        let isCancelled = false
        let single = false
        let q = fsQuery(
            collection(db, 'pages'),
            where('slug', '==', params.slug),
            where('visibility', '!=', 'draft')
        )
        if (id) {
            q = doc(db, 'pages', id)
            single = true
        }
        onSnapshot(q, (snapshot) => {
            if (isCancelled) {
                return
            }
            const output = []
            if (single) {
                if (snapshot.exists()) {
                    const data = snapshot.data()
                    if (
                        !isVerifying &&
                        !isAuthenticated &&
                        verificationComplete &&
                        (data.visibility === 'draft' || !data.profileActive)
                    ) {
                        dispatch(
                            dialogState(
                                JSON.stringify({ open: true, id: 'LOGIN' })
                            )
                        )
                    } else {
                        output.push(data)
                    }
                }
            } else {
                if (snapshot.empty) {
                    navigate('/404/')
                }
                snapshot.forEach((doc) => {
                    output.push(doc.data())
                })
            }

            setPageData(output[0])
        })
        return () => {
            isCancelled = true
        }
    }, [id, verificationComplete])

    return (
        <Layout
            location={location}
            pageTitle={pageData?.title}
        >
            {pageData ? (
                <PageBuilder
                    auxData={auxData}
                    dataFallback={fallback}
                    data={pageData}
                    id={pageData.slug}
                />
            ) : (
                <Loader />
            )}
        </Layout>
    )
}
function mapStateToProps(state) {
    return {
        isAuthenticated: state.Auth.isAuthenticated,
        isVerifying: state.Auth.isVerifying,
        verificationComplete: state.Auth.verificationComplete,
        previewID: state.Preview.id,
    }
}

export default connect(mapStateToProps)(Page)

export const query = graphql`
    query {
        allCollection(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    media {
                        set {
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_published
                    published_by
                    slug
                    title
                    item_id
                    categories
                    content {
                        description
                        excerpt
                    }
                }
            }
        }
        allPost(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    categories
                    content {
                        description
                        excerpt
                    }
                    media {
                        set {
                            caption
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_added
                    slug
                    title
                    date_published
                }
            }
        }
        allPage(filter: { visibility: { eq: "public" } }) {
            edges {
                node {
                    content {
                        description
                        excerpt
                    }
                    media {
                        set {
                            caption
                            filename
                            filepath
                            media_type
                            public_id
                        }
                    }
                    date_added
                    slug
                    title
                    date_published
                }
            }
        }
    }
`
